module.exports = __webpack_public_path__ + "static/img/gamma.d1ff46b4.png";